import React,{useEffect,useState}from'react';
async function api(u,o){const r=await fetch(u,{credentials:'include',headers:{'Content-Type':'application/json'},...o}),j=await r.json().catch(()=>({}));if(!r.ok)throw Error(j.error||'Request failed');return j}
const badge={overdue:'bg-red-100 text-red-800',due_soon:'bg-amber-100 text-amber-800',current:'bg-emerald-100 text-emerald-800'};
const label={overdue:'Overdue',due_soon:'Due Soon',current:'Current'};
export default function AdminPCASupervision(){
  const[list,setList]=useState([]),[summary,setSummary]=useState({}),[employees,setEmployees]=useState([]),[e,setE]=useState('');
  const[recordingFor,setRecordingFor]=useState(null),[form,setForm]=useState({});
  const load=()=>Promise.all([api('/api/dhhs-compliance/pca-supervision'),api('/api/dhhs-compliance/pca-supervision/summary'),api('/api/employees')])
    .then(([a,b,c])=>{setList(a);setSummary(b);setEmployees(c)}).catch(x=>setE(x.message));
  useEffect(()=>{load()},[]);
  const submit=async(employeeId)=>{
    if(!form.supervision_date){setE('Supervision date is required.');return}
    try{await api('/api/dhhs-compliance/pca-supervision',{method:'POST',body:JSON.stringify({...form,employee_id:employeeId})});setRecordingFor(null);setForm({});setE('');load()}
    catch(x){setE(x.message)}
  };
  return <div className="min-h-screen bg-slate-50 p-5 space-y-5">
    <header>
      <h1 className="text-3xl font-black">PCA Supervision</h1>
      <p className="text-slate-600">Every Personal Care Service Provider must be directly supervised at least every 6 months. Every active field-duty staff member is listed below, even if never yet supervised.</p>
    </header>
    {e&&<div className="bg-red-50 p-3 rounded-lg text-red-800">{e}</div>}
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      {['overdue','due_soon','current'].map(k=>
        <div key={k} className="rounded-2xl border bg-white p-4">
          <div className="text-xs uppercase text-slate-500">{label[k]}</div>
          <div className="text-2xl font-black">{summary[k]||0}</div>
        </div>
      )}
    </div>
    <section className="rounded-2xl border bg-white p-4">
      <h2 className="text-xl font-black">Field Duty Staff</h2>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left"><th>Employee</th><th>Last Supervised</th><th>Next Due</th><th>Status</th><th>Action</th></tr></thead>
          <tbody>
            {list.map(x=>
              <tr key={x.employee_id} className="border-t">
                <td className="py-3 font-bold">{x.employee_name}</td>
                <td>{x.supervision_date || 'Never supervised'}</td>
                <td>{x.next_due_date || '—'}</td>
                <td><span className={`px-2 py-1 rounded-full text-xs font-bold ${badge[x.status]}`}>{label[x.status]}</span></td>
                <td>
                  {recordingFor===x.employee_id ? (
                    <div className="flex gap-2 items-center flex-wrap">
                      <select className="border p-1 text-xs" onChange={ev=>setForm({...form,supervisor_employee_id:ev.target.value})}>
                        <option value="">Supervisor…</option>
                        {employees.map(emp=><option key={emp.employee_id} value={emp.employee_id}>{emp.first_name} {emp.last_name}</option>)}
                      </select>
                      <input type="date" className="border p-1 text-xs" onChange={ev=>setForm({...form,supervision_date:ev.target.value})}/>
                      <input className="border p-1 text-xs" placeholder="Notes (optional)" onChange={ev=>setForm({...form,notes:ev.target.value})}/>
                      <button className="text-emerald-700 font-bold" onClick={()=>submit(x.employee_id)}>Save</button>
                      <button className="text-slate-500" onClick={()=>{setRecordingFor(null);setForm({})}}>Cancel</button>
                    </div>
                  ) : (
                    <button className="text-blue-700 font-bold" onClick={()=>setRecordingFor(x.employee_id)}>Record Supervision</button>
                  )}
                </td>
              </tr>
            )}
            {!list.length && <tr><td colSpan={5} className="py-6 text-center text-slate-400">No active field duty staff found.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  </div>;
}
